import {useMutation} from '@tanstack/react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

export const usePersistRmcOrder = () => {
  return useMutation({
    mutationFn: mutations.persistRmcOrder,
    onMutate: async ({siteNumber}) => {
      await hubQueryClient.invalidateQueries({queryKey: ['persistedRmcOrder', siteNumber]})
    },
    onSuccess: (data, {siteNumber}) => {
      hubQueryClient.setQueryData(['persistedRmcOrder', siteNumber], data)
    }
  })
}
